<template>
    <Header></Header>
    <Left></Left>
    <section class="container">
        <div>
            <div class="area_title">
                <p>민원</p>
                <div class="area_button">
                    <button type="button" @click="downloadFile">
                        <img src="img/excel.png" />
                        <span>Excel 다운</span>
                    </button>

                    <button type="button" @click="router.push({ name: 'complainAdd' })">
                        <span>등록</span>
                    </button>
                </div>
            </div>
            <div class="area_body">
                <div class="area_section">
                    <div class="area_search">
                        <!-- <div>
                            <label>작성일</label>
                            <div>
                                <div class="datepicker"><input type="date" id="startDate" v-model="state.startDate" @change="changeStartDate" /></div>
                                <span>~</span>
                                <div class="datepicker"><input type="date" id="endDate" v-model="state.endDate" @change="changeEndDate" /></div>
                                <button
                                    type="button"
                                    @click="
                                        setDateToToday();
                                        fnGetList(1);
                                    "
                                >
                                    오늘날짜
                                </button>
                            </div>
                        </div> -->
                        <div>
                            <label>검색조건</label>
                            <div>
                                <div class="select-wrap">
                                    <select name="searchType" v-model="state.searchType1">
                                        <option value="">선택해주세요.</option>
                                        <option v-for="item in searchCondition" :value="item.key">{{ item.name }}</option>
                                    </select>
                                </div>
                                <template v-if="state.searchType1 !== 'complainantType' && state.searchType1 !== 'resultType'">
                                    <input
                                        type="text"
                                        name="searchText"
                                        v-model="state.searchText1"
                                        placeholder="검색어를 입력해주세요."
                                        v-on:keyup.enter="fnGetList(1)"
                                    />
                                </template>
                                <template v-else>
                                    <div class="select-wrap">
                                        <select
                                            name="searchType"
                                            v-model="state.searchText1"
                                            v-if="state.searchType1 === 'complainantType'"
                                            @change="fnGetList(1)"
                                        >
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in complainantTypeList" :value="item.key">{{ item.name }}</option>
                                        </select>

                                        <select name="searchType" v-model="state.searchText1" v-else @change="fnGetList(1)">
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in resultTypeList" :value="item.key">{{ item.name }}</option>
                                        </select>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <div class="area_button">
                            <button
                                type="button"
                                @click="
                                    reset();
                                    fnGetList(1);
                                "
                            >
                                초기화
                            </button>
                            <button type="button" @click="fnGetList(1)">검색</button>
                        </div>
                    </div>
                </div>

                <div class="area_section">
                    <div class="area_table">
                        <div class="area_table_head">
                            <div class="select-wrap">
                                <select name="orderType" v-model="state.order" @change="fnGetList(1)">
                                    <option value="0">최근순</option>
                                    <option value="1">과거순</option>
                                </select>
                            </div>

                            <div class="total_length">
                                {{ $t("notice.total") }} : {{ CommonUtils.numberFormat(pageState.length) }} {{ $t("notice.count") }}
                            </div>
                        </div>
                        <div class="area_table_body">
                            <DataGrid
                                :list="pageState.list"
                                :columns="pageState.fields"
                                :totalLength="pageState.length"
                                :perPage="pageState.perPage"
                                :cntPage="pageState.cntPage"
                                :current-page="pageState.currentPage"
                                :isLoading="pageState.isLoading"
                                @onRowClick="fnRowClick"
                                @onPaging="fnGetList"
                                @onNextPage="fnGoPage"
                                @onPrevPage="fnGoPage"
                                @onFirstPage="fnGoPage"
                                @onLastPage="fnGoPage"
                            ></DataGrid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <Spinner :is-full-page="true" v-if="state.isLoading"></Spinner>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="state.isShowModal = false"
    ></ModalDefault>
</template>
<script lang="ts" config>
    import {
        userStore,
        globalStore,
        DataGrid,
        reactive,
        watch,
        apiService,
        onActivated,
        router,
        Header,
        Left,
        ModalDefault,
        types,
        getMessageByCode,
        PageBtn,
        CommonUtils,
        CommonOptions,
        useRoute,
        Spinner,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { Header, Left, ModalDefault, PageBtn, DataGrid, Spinner },
        setup() {
            const route = useRoute();
            const dayAgo = new Date();
            const today = new Date();
            dayAgo.setDate(today.getDate() - 90);

            const state = reactive({
                startDate: "" as string,
                endDate: "" as string,
                searchType1: "" as string,
                searchText1: "" as string,
                dept: 0 as number,
                order: 0 as number,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalTitle: "alert" as string,
                modalContent: "" as string,
                isLoading: false,
            });

            const searchCondition = [
                { key: "complainant", name: "이름" },
                { key: "phoneNum", name: "연락처" },
                { key: "complainantType", name: "문의자 구분" },
                { key: "writer", name: "작성자" },
                { key: "resultType", name: "조치결과" },
            ];

            const complainantTypeList = [
                { key: 1, name: "여성폭력 피해자" },
                { key: 2, name: "종결 내담자" },
                { key: 3, name: "제보자" },
                { key: 4, name: "유관기관" },
                { key: 5, name: "성매매 알선자" },
                { key: 6, name: "성매수자" },
                { key: 7, name: "경찰/검찰/법원" },
                { key: 8, name: "기타" },
            ];

            const resultTypeList = [
                { key: 1, name: "대기" },
                { key: 2, name: "완료" },
            ];

            const pageState = reactive({
                perPage: 10,
                cntPage: 5,
                currentPage: 1,
                list: [] as any,
                length: 0 as number,
                isLoading: false,
                fields: [
                    { key: "", label: "No.", class: "text-center" },
                    {
                        key: "date",
                        label: "작성일",
                        class: "text-center",
                        render: (row: any) => {
                            return CommonUtils.dateFormatYYMMDD(row.date, ".");
                        },
                    },
                    {
                        key: "title",
                        label: "제목",
                        class: "text-left underline",
                        clickable: true,
                    },
                    { key: "complainant", label: "이름", class: "text-center" },
                    {
                        key: "phoneNum",
                        label: "연락처",
                        class: "text-center",
                        render: (row: any) => {
                            if (row.phoneNum) return CommonUtils.convertPhoneNum(row.phoneNum);
                            return "";
                        },
                    },
                    {
                        key: "complainantType",
                        label: "문의자 구분",
                        class: "text-center",
                        render: (row: any) => {
                            switch (row.resultType) {
                                case 1:
                                    return "여성폭력 피해자";
                                case 2:
                                    return "종결 내담자";
                                case 3:
                                    return "제보자";
                                case 4:
                                    return "유관기관";
                                case 5:
                                    return "성매매 알선자";
                                case 6:
                                    return "성매수자";
                                case 7:
                                    return "경찰/검찰/법원";
                                default:
                                    return "기타";
                            }
                        },
                    },
                    { key: "writer", label: "작성자", class: "text-center" },
                    {
                        key: "resultType",
                        label: "조치결과",
                        class: "text-center",
                        render: (row: any) => {
                            switch (row.resultType) {
                                case 1:
                                    return "대기";
                                case 2:
                                    return "완료";
                                default:
                                    return "-";
                            }
                        },
                    },
                ],
            });

            onActivated(() => {
                if (!route.query.dept) {
                    state.dept = 0;
                } else {
                    state.dept = Number(route.query.dept);
                }
                router.replace({ name: "complain", query: { dept: state.dept } });

                state.startDate = dayAgo.toLocaleDateString("sv-SE");
                state.endDate = today.toLocaleDateString("sv-SE");
                fnGetList(pageState.currentPage);
            });

            watch(
                () => route.query.dept,
                () => {
                    if (route.name !== "complain") return;
                    if (!route.query.dept) {
                        state.dept = 0;
                        pageState.currentPage = 1;
                        router.replace({ name: "complain", query: { dept: state.dept } });
                    } else if (Number(route.query.dept) !== state.dept) {
                        state.dept = Number(route.query.dept);
                        pageState.currentPage = 1;
                    }
                    // state.startDate = dayAgo.toLocaleDateString("sv-SE");
                    // state.endDate = today.toLocaleDateString("sv-SE");
                    fnGetList(pageState.currentPage);
                },
            );

            const reset = () => {
                state.startDate = "";
                state.endDate = "";
                state.searchType1 = "";
                state.searchText1 = "";
                state.dept = 0;
                state.order = 0;
            };

            const fnGetList = async (page: number) => {
                pageState.currentPage = page;
                pageState.isLoading = true;
                const param: types.complain.ReqComplainList = {
                    page: page,
                    size: pageState.perPage,
                    searchType: state.searchType1,
                    searchText: state.searchText1,
                    order: state.order,
                    startDate: state.startDate,
                    endDate: state.endDate,
                };

                let res: types.ResPaging = await apiService.complain.list(param);
                if (res.returnCode === 0 && res.list) {
                    pageState.list = res.list.data;
                    pageState.length = res.list.recordsTotal;
                } else {
                    console.error(res.description);
                }
                pageState.isLoading = false;
            };

            const fnRowClick = (row: any, col: any) => {
                if (col.key === "title") {
                    router.push({ name: "complainDetail", params: { id: row.idx } });
                }
            };

            const fnGoPage = (page: number) => {
                pageState.currentPage = page;
            };

            const setDateToToday = () => {
                state.startDate = dayAgo.toLocaleDateString("sv-SE");
                state.endDate = today.toLocaleDateString("sv-SE");
            };

            const downloadFile = async () => {
                state.isLoading = true;
                try {
                    const param: types.complain.ReqComplainList = {
                        page: 0,
                        size: 0,
                        searchType: state.searchType1,
                        searchText: state.searchText1,
                        order: state.order,
                        startDate: state.startDate,
                        endDate: state.endDate,
                    };
                    let res = await apiService.complain.exportExcel(param);
                    if (res && res.data) {
                        const blob = new Blob([res.data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });
                        const disposition = res.headers["content-disposition"];
                        let fileName = "download.xlsx";
                        if (disposition) {
                            const match = disposition.match(/filename="?(.+)"?/);
                            if (match && match[1]) {
                                fileName = decodeURIComponent(match[1]);
                            }
                        }
                        const a = document.createElement("a");
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("파일 다운로드 실패:", err);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "파일 다운로드 실패";
                    state.isShowModal = true;
                }
                state.isLoading = false;
            };

            const changeStartDate = () => {
                if (!CommonUtils.checkDateRange(state.startDate, state.endDate)) {
                    state.endDate = state.startDate;
                }
            };
            const changeEndDate = () => {
                if (!CommonUtils.checkDateRange(state.startDate, state.endDate)) {
                    state.endDate = state.startDate;
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "작성일 범위가 잘못 선택되었습니다.";
                    state.isShowModal = true;
                }
            };

            return {
                state,
                pageState,
                router,
                reset,
                fnRowClick,
                fnGoPage,
                fnGetList,
                CommonUtils,
                setDateToToday,
                searchCondition,
                complainantTypeList,
                resultTypeList,
                CommonOptions,
                downloadFile,
                window,
                changeStartDate,
                changeEndDate,
            };
        },
    };
</script>
<style>
    .sch_list label:last-child {
        border-right: white;
    }
</style>
